<template>
  <v-dialog scrollable v-model="showModalInternal" max-width="400px" @close="onClose">
    <v-card>
      <v-card-title class="d-flex justify-space-between align-start flex-nowrap">
        <div class="flex-grow-1 d-flex align-center"><v-icon left>mdi-calculator</v-icon>{{ trans('misc.calculateTaxFromNet') }}</div>
        <v-btn icon small class="ml-2" @click="close"><v-icon small>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <div class="mt-2">
          <currency-input
            :label="trans('misc.priceNet')"
            v-model="amountNet"
            currency="EUR"
            style="max-width: 250px"
            @input="calculatePriceIfPossible"
            autofocus
            :allow-only-negative="allowOnlyNegative"
          ></currency-input>
          <v-combobox
            :label="trans('misc.vatPercent')"
            :items="[19, 7]"
            v-model="taxPercent"
            suffix="%"
            style="max-width: 150px"
            @change="calculatePriceIfPossible"
          ></v-combobox>
          <currency-input
            :label="trans('misc.tax')"
            :value="amountTax"
            currency="EUR"
            style="max-width: 250px"
            disabled
          ></currency-input>
          <currency-input
            :label="trans('misc.priceGross')"
            :value="amountGross"
            currency="EUR"
            style="max-width: 250px"
            disabled
          ></currency-input>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <cancel-button @click="close" />
        <v-btn color="primary" @click="emitPrice" :disabled="!amountNet">
          <v-icon left>mdi-arrow-right</v-icon>
          {{ trans('general.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {LocaleUtils} from '../utils/locale-utils';
import CurrencyInput from './CurrencyInput';
import CancelButton from './CancelButton';

export default {
  name: 'TaxGrossFromNetModal',
  components: {CancelButton, CurrencyInput},
  mixins: [
    LocaleUtils
  ],
  props: {
    showModal: {},
    allowOnlyNegative: {
      type: Boolean,
      default () {
        return false;
      }
    }
  },
  data () {
    return {
      showModalInternal: false,
      amountNet: null,
      taxPercent: 19,
      amountGross: null,
      amountTax: null
    }
  },
  beforeDestroy () {
    this.close();
    this.$emit('update:show-modal', false);
  },
  watch: {
    showModal (showModal) {
      this.showModalInternal = showModal;
      if (!showModal) {
        this.amountNet = null;
        this.amountGross = null;
        this.amountTax = null;
      }
    },
    showModalInternal (showModalInternal) {
      this.$emit('update:show-modal', showModalInternal);
    }
  },
  methods: {
    onClose () {
      this.$emit('close');
    },
    close () {
      this.showModalInternal = false;
    },
    calculatePriceIfPossible () {
      if (this.amountNet && this.taxPercent) {
        this.amountTax = this.amountNet * this.taxPercent / 100;
        this.amountGross = this.amountNet + this.amountTax;
      }
    },
    emitPrice () {
      this.$emit('calculation', {gross: this.amountGross, tax: this.amountTax});
      this.close();
    }
  },
  computed: {

  }
}
</script>
